<template>
    <div>
      <router-view/>
    </div>
</template>

<script>
  export default {
    name: 'bargainingIndex'
  }
</script>

<style scoped>

</style>
